import { render } from "./OrganizationSystemBanner.vue?vue&type=template&id=70cc5a54&scoped=true&ts=true"
import script from "./OrganizationSystemBanner.vue?vue&type=script&lang=ts"
export * from "./OrganizationSystemBanner.vue?vue&type=script&lang=ts"

import "./OrganizationSystemBanner.vue?vue&type=style&index=0&id=70cc5a54&lang=scss&scoped=true"
import "./OrganizationSystemBanner.vue?vue&type=style&index=1&id=70cc5a54&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70cc5a54"]])

export default __exports__